import { useNavigate } from "react-router-dom";
import { useMarketingTracking } from "../../marketing.analytics";
import { MarketingAudienceCards } from "./MarketingAudienceCards";
import type { AudienceCta } from "./marketingAudienceCtas.data";

export type Props = {
  className?: string;
};

/** Container for MarketingAudienceCards: records the click, then navigates. */
export function MarketingAudienceCardsContainer({ className }: Props) {
  const navigate = useNavigate();
  const { trackCtaClick } = useMarketingTracking();

  const handleCtaClick = (cta: AudienceCta) => {
    trackCtaClick(cta.label, cta.formSlug ? { form_slug: cta.formSlug } : {});
    navigate(cta.href);
  };

  return <MarketingAudienceCards onCtaClick={handleCtaClick} className={className} />;
}

export default MarketingAudienceCardsContainer;
